import { render, staticRenderFns } from "./BoxCustomerJourney.vue?vue&type=template&id=17a3b556&scoped=true&"
import script from "./BoxCustomerJourney.vue?vue&type=script&lang=ts&"
export * from "./BoxCustomerJourney.vue?vue&type=script&lang=ts&"
import style0 from "./BoxCustomerJourney.vue?vue&type=style&index=0&id=17a3b556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a3b556",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon})
